import { Badge, HStack } from "@chakra-ui/react"
import { Asset, AssetStatus, TenantStatusCopyType } from "@hydrologiq/gql-experience/graphql"
import { JSX } from "react"
import { statusToText } from "../attributes/status"
import { useCopyStatuses } from "@hydrologiq/shared/providers/helpers/useCopy"
import { getAssetStatusColor, getAssetStatusTextColor } from "./statusColors"

function StatusBadge(props: {
  asset: Asset | Asset
  status?: AssetStatus
  edit?: boolean
  editComponent?: JSX.Element
  minWidth?: string | number
  width?: string | number
}) {
  const { asset, status, edit = true, editComponent, minWidth = "5.25rem", width } = props
  const statusToUse = status || asset.status

  const copy = useCopyStatuses(TenantStatusCopyType.Asset)
  const text = statusToText(statusToUse ?? AssetStatus.Available, copy)

  const background = getAssetStatusColor(statusToUse)
  const textColor = getAssetStatusTextColor(statusToUse)

  return (
    <HStack gap={1} alignItems="center">
      <Badge
        size="sm"
        backgroundColor={background}
        color={textColor}
        whiteSpace="nowrap"
        fontSize="0.75rem"
        minWidth={minWidth}
        width={width}
        display="inline-flex"
        justifyContent="center"
        textAlign="center"
      >
        {text}
      </Badge>
      {edit && editComponent}
    </HStack>
  )
}

export default StatusBadge
